import React, { createContext, FC, useEffect, useState } from 'react'
import { AxiosError } from 'axios'
import useGetSearchAccount from '../api/useGetSearchAccount'
import { SearchAccountsResponsePayload } from '@Types'

export type AccountContextProps = {
  setAccountNumber: (accountNumber: string) => void
  account: SearchAccountsResponsePayload
  isLoading: boolean
  error: AxiosError
}

export const AccountContext = createContext<AccountContextProps | {}>({
  setAccountNumber: () => {}
})

const AccountProvider: FC = ({ children }) => {
  const [accountNumber, setAccountNumber] = useState<string>('')
  const { refetch, data, isLoading, error } = useGetSearchAccount(accountNumber?.toUpperCase())

  useEffect(() => {
    if (accountNumber) {
      refetch()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountNumber])

  const account = data && data[0]

  return (
    <AccountContext.Provider
      value={{
        setAccountNumber,
        account,
        isLoading,
        error
      }}
    >
      {children}
    </AccountContext.Provider>
  )
}

export default AccountProvider
